module.exports = __webpack_public_path__ + "img/fuwai.6825aaff.png";